export const SyncRunStatus = {
  SUCCEEDED: 'succeeded',
  RUNNING: 'running',
  ERRORED: 'errored',
  SUCCEEDED_WITH_ERRORS: 'succededwitherrors',
} as const

export type SyncRunStatusTypes = (typeof SyncRunStatus)[keyof typeof SyncRunStatus]
